var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.emojiPageStatus),expression:"emojiPageStatus"}],staticClass:"emoji--modal",class:{
    open: _vm.emojiPageStatus
  }},[_c('button',{staticClass:"emoji--modal--button",on:{"click":_vm.disableEmojiPage}}),_c('div',{staticClass:"octadesk-emoji-picker--content"},[_c('EmojiPicker',{on:{"select":_vm.handleEmojiSelection}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }